"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = Input;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const base_input_1 = require("../base-input");
const field_block_1 = require("../field-block");
const utils_1 = require("./utils");
const events_1 = require("../helpers/events");
const CircleCross_1 = __importDefault(require("@sima-land/ui-quarks/icons/16x16/Filled/CircleCross"));
const CircleCross_2 = __importDefault(require("@sima-land/ui-quarks/icons/24x24/Filled/CircleCross"));
const bind_1 = __importDefault(require("classnames/bind"));
const input_m_scss_1 = __importDefault(require("./input.m.scss"));
const cx = bind_1.default.bind(input_m_scss_1.default);
/**
 * Текстовое поле.
 * @param props Свойства.
 * @return Элемент.
 */
function Input({ 
// specific Input props
inputRef, baseInputProps, clearable, onClear, 
// root props
style, className, 
// input element props (popular)
autoComplete, autoFocus, defaultValue, disabled, id, name, onBlur, onChange, onFocus, onInput, placeholder, readOnly, required, type, value, 
// FieldBlock props
size, label, failed, caption, blockProps, focused: focusedProp, 'data-testid': testId = 'input', ...restProps }) {
    const ref = (0, react_1.useRef)(null);
    const [filled, updateFilled] = (0, utils_1.useFilledState)(ref, { value, defaultValue });
    const [focused, setFocused] = (0, react_1.useState)(false);
    const CrossSVG = size === 's' ? CircleCross_1.default : CircleCross_2.default;
    const handleMouseDown = (0, utils_1.useFieldMouseDown)(ref, blockProps?.onMouseDown);
    (0, react_1.useImperativeHandle)(inputRef, () => ref.current);
    (0, react_1.useImperativeHandle)(baseInputProps?.inputRef, () => ref.current);
    return ((0, jsx_runtime_1.jsx)(field_block_1.FieldBlock, { ...restProps, rootProps: {
            ...restProps.rootProps,
            style,
            className,
        }, "data-testid": testId, caption: caption, disabled: disabled, failed: failed, focused: focusedProp ?? focused, label: label, labelAsPlaceholder: !focused && !filled, labelProps: { htmlFor: id }, size: size, ...(clearable &&
            focused &&
            filled && {
            adornmentEnd: ((0, jsx_runtime_1.jsx)(CrossSVG, { "data-testid": 'input:clear-button', role: 'button', "aria-label": '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u043F\u043E\u043B\u0435', className: cx('clear-button'), onClick: e => {
                    ref.current && (0, events_1.triggerInput)(ref.current, '');
                    onClear?.(e);
                } })),
        }), blockProps: {
            ...blockProps,
            onMouseDown: handleMouseDown,
        }, main: (0, jsx_runtime_1.jsx)(base_input_1.BaseInput, { ...baseInputProps, inputRef: ref, multiline: false, className: cx('input', disabled && 'disabled', baseInputProps?.className), style: {
                '--base-input-placeholder-color': (0, utils_1.definePlaceholderColor)({ failed, disabled }),
                ...baseInputProps?.style,
            }, autoComplete: autoComplete, autoFocus: autoFocus, defaultValue: defaultValue, disabled: disabled, id: id, name: name, placeholder: !focused ? label || placeholder : placeholder, readOnly: readOnly, required: required, type: type, value: value, onFocus: event => {
                onFocus?.(event);
                updateFilled(event);
                setFocused(true);
            }, onBlur: event => {
                onBlur?.(event);
                updateFilled(event);
                setFocused(false);
            }, onInput: event => {
                onInput?.(event);
                updateFilled(event);
            }, onChange: event => {
                onChange?.(event);
                updateFilled(event);
            } }), mainProps: { className: cx('main') } }));
}
//# sourceMappingURL=input.js.map